import addPublicFolderToStore from '../actions/addPublicFolderToStore';
import { Folder, SourceWellKnownFolderType } from 'owa-folders';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import FolderType from 'owa-service/lib/contract/Folder';
import { mutator } from 'satcheljs';
import {
    getIsFolderHiddenProperty,
    getSourceWellKnownFolderTypeProperty,
} from 'owa-folders-common';

export default mutator(addPublicFolderToStore, actionMessage => {
    const { state, item } = actionMessage;
    let folderId = item.FolderId.Id;

    if (!state.folderTable.has(folderId)) {
        let distinguishedFolderIdName = item.DistinguishedFolderId
            ? <DistinguishedFolderIdName>item.DistinguishedFolderId
            : undefined;

        let folder: Folder = {
            ...{
                childFolderIds: [],
                distinguishedFolderId: distinguishedFolderIdName,
                UnreadCount: (<FolderType>item).UnreadCount,
                TotalCount: item.TotalCount,
                isHidden: getIsFolderHiddenProperty(item),
                sourceWellKnownFolderType: <SourceWellKnownFolderType>(
                    getSourceWellKnownFolderTypeProperty(item)
                ),
                ReplicaList: item.ReplicaList,
            },
            ...item,
        };

        state.folderTable.set(folderId, folder);
    }
});
